import Modal from '@cred/react-modal'
import { withModalInteraction } from '@cred/react-analytics/hoc'

const ModalWithAnalytics = withModalInteraction(Modal)

export default ModalWithAnalytics
